import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { t } from "i18next"
import { dateToString, getNextBillingDate } from "../../helpers/date.helpers"
import { getActionFromLicense, UpgradeAction, UserLicenseType } from "../../helpers/license.helpers"
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux"
import { upgradeUserLicenseAsync } from "../../store/slices/user.slice"
import { Transition } from "../common/Transition"
import { confirmOnEnter } from "../../helpers/dialog.helpers"

interface Props {
    open: boolean
    licenseType: UserLicenseType | undefined
    onClose: () => void
}

const UpgradeDialog = ({ open, onClose, licenseType }: Props) => {
    const theme = useTheme()
    const user = useAppSelector((state) => state.user.value)
    const dispatch = useAppDispatch()
    const action = getActionFromLicense(licenseType)

    const handleConfirm = () => {
        dispatch(
            upgradeUserLicenseAsync(user, {
                license: [UpgradeAction.Upgrade, UpgradeAction.KeepUnlimited].includes(action!)
                    ? "enterprise"
                    : "free",
            })
        )
        onClose()
    }

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            onKeyDown={confirmOnEnter(handleConfirm)}
            aria-describedby="alert-dialog-slide-description"
        >
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    minWidth: { lg: 500, sm: "auto" },
                    pt: 1,
                    pl: 1,
                    pb: 2,
                    pr: 2,
                }}
            >
                <DialogTitle>{t(`user:${action}.title`)}</DialogTitle>
                <DialogContent>
                    <DialogContentText align="justify">
                        {t(`user:${action}.text`, {
                            next: dateToString(getNextBillingDate(user.license?.started!)),
                        })}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="text"
                        color="inherit"
                        sx={{ px: 2 }}
                        disabled={false}
                        onClick={onClose}
                    >
                        {t("disagree")}
                    </Button>
                    <Button variant="contained" sx={{ px: 2 }} onClick={handleConfirm}>
                        {t(`user:${action}.button`)}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default UpgradeDialog
